import { createAction, props } from '@ngrx/store';
import { AdditionalField } from 'app/store/project/addition-fields/addition-fields.reducer';

export const writeAdditions = createAction('[Addition Fields Store] Write Additions', props<{ fields: AdditionalField[] }>());
